<template>
  <div class="flex-column-top-container">
    <SystemNotification />
    <EnvironmentBanner />
    <SACSnackBar />
    <div id="navbar">
      <div class="navbar-container">
        <div class="left-container">
          <router-link to="/service" class="home-link">
            <img
              class="logo"
              src="@shared/assets/img/logo/white-short.png"
              alt="SmartAC.com"
            />
          </router-link>
        </div>
        <nav class="middle-container">
          <NavItem
            v-if="!appOnly"
            to="/adoption"
            label="Adoption"
            :active="currentPage.includes('/adoption')"
            icon="adoption.svg"
            activeIcon="adoption-active.svg"
            iconClass="med-img"
          />
          <NavItem
            to="/technician"
            label="Technicians"
            :active="currentPage.includes('/technician')"
            icon="technician.svg"
            activeIcon="technician-active.svg"
            iconClass="technician-img"
          />
          <NavItem
            to="/service"
            label="Service"
            :active="currentPage.includes('/service')"
            icon="service.svg"
            activeIcon="service-active.svg"
            iconClass="hvac-img"
          />
          <NavItem
            redirect="/fyb"
            label="Fill Your Board"
            :active="currentPage.includes('/fyb')"
            icon="fyb.svg"
            activeIcon="fyb-active.svg"
            iconClass="home-img"
          />
          <NavItem
            v-if="!appOnly"
            to="/systemhealth"
            label="System Health"
            :active="currentPage.includes('/systemhealth')"
            icon="system-health.png"
            activeIcon="system-health-active.png"
            iconClass="home-img"
          />
          <NavItem
            to="/member"
            label="Members"
            :active="currentPage === '/member' || currentPage.includes('/member/')"
            icon="member.svg"
            activeIcon="member-active.svg"
            iconClass="customer-img"
          />
          <NavItem
            to="/user-activities"
            label="User Activities"
            :active="currentPage === '/user-activities'"
            icon="activity.png"
            activeIcon="activity-active.png"
            iconClass="customer-img"
          />
          <NavItem
            to="/member-order"
            label="Member Orders"
            :active="currentPage.includes('/member-order')"
            icon="member-order.svg"
            activeIcon="member-order-active.svg"
            iconClass="order-img"
          />
          <NavItem
            to="/partner-order"
            label="Orders"
            :active="currentPage.includes('/partner-order')"
            icon="package.svg"
            activeIcon="package-active.svg"
            iconClass="order-img"
          />
          <NavItem
            redirect="/rewards"
            label="Rewards"
            :active="currentPage.includes('/rewards')"
            icon="comfort-credit.png"
            activeIcon="comfort-credit-active.png"
            iconClass="customer-img"
          />
          <NavItem
            redirect="/campaigns"
            label="Marketing"
            :active="currentPage.includes('/campaigns')"
            iconClass="customer-img"
            icon="megaphone.svg"
            activeIcon="megaphone-active.svg"
          />
          <NavItem
            to="/settings"
            label="Settings"
            :active="currentPage.includes('/settings')"
            icon="settings.png"
            activeIcon="settings-active.png"
            iconClass="small-img"
          />
        </nav>
        <div class="right-container">
          <div>
            <button type="button" class="search-btn" @click="openSearch">
              <span class="sac__font-14 f-white semi-bold"> Search </span>
              <img
                src="@shared/assets/img/general/search-white.png"
                alt="cycle"
                class="img-size-16"
              />
            </button>
          </div>
          <div>
            <button type="button" class="profile-container" @click="handleToggle">
              <img src="@shared/assets/img/navbar/admin.png" alt="admin" />
            </button>
            <div :class="[show ? 'active' : '', 'profile-dropdown-container']">
              <div class="pd-list-header">
                <span class="pdl-title"> Signed-in </span>
                <span class="pdl-body">{{ current.email }}</span>
                <div class="pdl-body flex-column">
                  <router-link :to="{ path: '/settings' }"> Settings </router-link>
                  <router-link :to="{ path: '/settings/?setting=account' }">
                    My Profile
                  </router-link>
                </div>
              </div>
              <button type="button" class="pd-list-item" @click="logout">
                <span class="pd-li-icon-container">
                  <img
                    alt="logout"
                    class="logout"
                    src="@shared/assets/img/navbar/logout.png"
                  />
                </span>
                <span class="pd-li-label">Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ActionModal />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SACSnackBar from "@shared/components/sac/SACSnackBar.vue";
import ActionModal from "@shared/components/navbar/ActionModal.vue";
import SystemNotification from "@shared/components/navbar/SystemNotification.vue";
import EnvironmentBanner from "@shared/components/navbar/EnvironmentBanner.vue";
import NavItem from "@shared/components/navbar/NavItem.vue";

import launchDarklyClient from "@shared/lib/general/launchDarklyClient";

export default {
  name: "NavbarComponent",
  components: {
    ActionModal,
    NavItem,
    SystemNotification,
    EnvironmentBanner,
    SACSnackBar,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.admin.current,
      partnerSettings: (state) => state.admin.partnerSettings,
      appOnly: (state) => state.admin.appOnly,
      allCorpPlans: (state) => state.customerDetail.allCorpPlans,
    }),
    ...mapGetters(["adminRole", "todayEvents", "partnerSettings"]),
    currentPage() {
      return this.$route.path;
    },
    showServiceRequest() {
      const { SERVICE_REQUEST_HANDLE_REQUEST = "" } = this.partnerSettings;
      let show = false;
      if (SERVICE_REQUEST_HANDLE_REQUEST === "smac") {
        show = true;
      }
      return show;
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
    window.addEventListener("keyup", this.handleKeyup);
    document
      .querySelector(":not(.profile-dropdown-container)")
      .addEventListener("click", this.closeOnClick);
    this.$store.dispatch("getPartnerProviderPlans");
  },
  destroyed() {
    document
      .querySelector(":not(.profile-dropdown-container)")
      .removeEventListener("click", this.closeOnClick);
  },
  methods: {
    openSearch() {
      const changes = [
        {
          field: "showSearch",
          value: true,
        },
      ];
      this.$store.dispatch("changeAdminValues", changes);
    },
    handleKeydown(e) {
      if (e.metaKey || e.ctrlKey) {
        this.metaPressed = true;
      }
      // Check if 'K' is pressed while metaKey is also pressed
      if (this.metaPressed && e.key === "k") {
        e.preventDefault();
        const changes = [
          {
            field: "showSearch",
            value: true,
          },
        ];
        this.$store.dispatch("changeAdminValues", changes);
      }
    },
    handleKeyup(e) {
      if (e.key === "Meta" || e.key === "Control") {
        this.metaPressed = false;
      }
    },
    logout() {
      this.$store.dispatch("logoutAdmin");
      launchDarklyClient.close();
      localStorage.clear();
      this.$intercom.shutdown();
      this.$router.push("/login");
    },
    handleToggle() {
      this.show = !this.show;
    },
    closeOnClick(e) {
      if (
        !e.target.closest(".profile-container") &&
        !e.target.closest(".profile-dropdown-container") &&
        this.show
      ) {
        this.show = false;
      }
    },
  },
};
</script>

<style lang="scss">
.flex-column-top-container {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}

#navbar {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: $BLACK;
  padding: 0 100px;
  box-shadow: 0 1px 2px rgba(9, 15, 32, 0.2);
  z-index: 11;

  @media (max-width: 1279px) {
    padding: 0 60px;
  }

  @media (max-width: 1023px) {
    padding: 0 40px;
  }

  .navbar-container {
    display: flex;
    align-items: center;
    max-width: 1705px;
    width: 100%;
    height: 64px;

    .left-container {
      .home-link {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;

        .logo {
          width: 34px;
          height: 17px;
        }
      }
    }

    .middle-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      .nav-link {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 64px;
        width: 64px;

        .nav {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;

          .logo-container {
            display: flex;

            .technician-img {
              width: 25px;
            }

            .lead-img {
              width: 25px;
            }

            .home-img {
              width: 20px;
              height: 20px;
            }

            .qc-img {
              width: 20px;
              height: 20px;
            }

            .customer-img {
              width: 19px;
              height: 20px;
            }

            .comparison-img {
              width: 20px;
              height: 20px;
            }

            .device-img {
              width: 16px;
              height: 20px;
            }

            .alert-img {
              width: 20px;
              height: 20px;
            }

            .order-img {
              width: 20px;
              height: 20px;
            }

            .qa-img {
              width: 19px;
              height: 20px;
            }

            .hvac-img {
              width: 20px;
              height: 20px;
            }

            .partner-img {
              width: 20px;
              height: 20px;
            }

            .test-img {
              width: 25px;
              height: 25px;
            }

            .small-img {
              width: 20px;
              height: 20px;
            }

            .med-img {
              width: 24px;
              height: 20px;
            }
          }

          .nav-label-container {
            display: none;
            position: absolute;
            background-color: $WHITE;
            top: 50px;
            padding: 7px 16px 7px 16px;
            box-shadow: 0px 3px 6px rgba(9, 15, 32, 0.07);
            border-radius: 6px;
            white-space: nowrap;

            &:hover {
              display: block;
            }

            &:after {
              content: "";
              position: absolute;
              top: 0;
              left: 50%;
              width: 0;
              height: 0;
              border: 8px solid transparent;
              border-bottom-color: $WHITE;
              border-top: 0;
              margin-left: -8px;
              margin-top: -8px;
            }

            .nav-label {
              width: 100%;
              font-size: 0.875rem;
              color: $BLACK;
            }
          }
        }

        .new {
          font-size: 11px;
          font-weight: 500;
          color: $TOMATO100;
        }

        &:hover {
          background-color: rgba(73, 121, 255, 0.1);

          .nav {
            .nav-label-container {
              display: block;
            }
          }
        }
      }
    }

    .right-container {
      display: grid;
      grid-auto-flow: column;
      justify-content: space-between;
      align-items: center;
      position: relative;
      gap: 1rem;
      .search-btn {
        background-color: $N90;
        border-radius: 6px;
        padding: 8px 16px;
        display: grid;
        grid-auto-flow: column;
        gap: 1rem;
        align-items: center;
      }
      .profile-container {
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
          width: 32px;
          height: 32px;
        }
      }

      .profile-dropdown-container {
        top: 65px;
        right: 0;
        position: absolute;
        background-color: $WHITE;
        box-shadow: 0px 3px 6px rgba(9, 15, 32, 0.07);
        border-radius: 6px;
        transition: transform 0.1s ease;
        transform: scaleY(0);
        transform-origin: top;

        &.active {
          transform: scaleY(1);
        }

        &:after {
          content: "";
          position: absolute;
          top: 0;
          right: 8px;
          width: 0;
          height: 0;
          border: 8px solid transparent;
          border-bottom-color: $WHITE;
          border-top: 0;
          margin-left: -8px;
          margin-top: -8px;
        }

        .pd-list-header {
          padding: 5px 12px 5px 14px;

          .pdl-title {
            font-size: 0.875rem;
          }

          .pdl-body {
            font-weight: 500;
          }
        }

        .pd-list-item {
          display: flex;
          align-items: center;
          padding: 5px 12px 5px 14px;
          cursor: pointer;
          border-top: 1px solid $N10;
          width: 100%;
          &:hover {
            background-color: $N10;
          }

          &:first-child {
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }

          &:last-child {
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
          }

          .pd-li-icon-container {
            display: flex;
            align-items: center;
            width: 25px;
            margin-right: 5px;

            .account {
              width: 15px;
              height: 17px;
            }

            .setting {
              width: 15px;
              height: 15px;
            }

            .logout {
              width: 13px;
              height: 13px;
            }
          }

          .pd-li-label {
            font-weight: 500;
            font-size: 0.875rem;
            color: $BLACK;
          }
        }
      }
    }
  }

  .slogan-container {
    display: flex;
    max-width: 1705px;
    width: 100%;
    margin-top: -12px;
    color: $WHITE;
    font-weight: 800;
  }
}
</style>
